
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import RoundedTableSlide from '@/components/TheMain/components/RoundedTableSlide'

export default {
  name: 'RoundedTableRAS',
  components: {
    Swiper,
    SwiperSlide,
    RoundedTableSlide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      swiperOptions: {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 45,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          dynamicBullets: true,
        },
      },
    }
  },
  methods: {
    handleScroll() {
      const offset = 20
      this.$scrollTo('#slider', {
        offset: -offset,
        behavior: 'smooth',
      })
    },
  },
}
